module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAYAAABb0P4QAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAYdEVYdFNvZnR3YXJlAHBhaW50Lm5ldCA0LjAuOBs0TtgAAACVSURBVDhPtZTRDYAgDAW7D0swAqs4Afu4FoPUAppQeBCD9eM+euE1kFaJmU2B8gtQtlAkJ/gbh860QJmRcBCSwB3ZBZTJYBnpaBrMOGF2EPVmqAFiuKkqisDPnJGGvCrqAFBwhRpU3zBPEoVWeNVDFT80tH1yEZZDKcJ6bYqUpe2CiHeL/SABu0+vRcI2P4ddoNyH6QJyyUIN2lGGjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doc_icons/procedure_green.png
// module id = FIaR
// module chunks = 1